import 'reflect-metadata';
import {jsonObject, jsonMember, TypedJSON} from 'typedjson';

import {ProfileSettings} from '@/model/network/settings/ProfileSettings';

@jsonObject
export class Profile {

  public static get Serializer(): TypedJSON<Profile> {
    if (!Profile.serializer) {
      Profile.serializer = new TypedJSON(Profile);
    }

    return Profile.serializer;
  }

  private static serializer: TypedJSON<Profile> | undefined;

  @jsonMember({name: 'unsaved'})
  public Unsaved!: boolean;

  @jsonMember({name: 'flags'})
  public Flags!: number;

  @jsonMember({name: 'filename'})
  public Filename!: string;

  @jsonMember({name: 'settings'})
  public Settings!: ProfileSettings;

  constructor(profile?: Profile | undefined) {
    if (profile) {
      this.Unsaved = profile.Unsaved;
      this.Flags = profile.Flags;
      this.Filename = profile.Filename;
      this.Settings = new ProfileSettings(profile.Settings);
    }
  }

  get Id(): string {
    return this.Settings?.Connection.Id ?? '';
  }

  get Name(): string {
    return this.Settings?.Connection.Id ?? '';
  }
}

